export const ADD_USER = 'ADD_USER';
export const LOG_OUT = 'LOG_OUT';
export const ADD_GENERAL_INFO = 'ADD_GENERAL_INFO';
export const ADD_DESCRIPTION = 'ADD_DESCRIPTION';
export const ADD_ATTACHMENTS = 'ADD_ATTACHMENTS';
export const ADD_NEXT_ITEM = 'ADD_NEXT_ITEM';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
export const CHANGE_NAVBAR_VISIBILITY = 'CHANGE_NAVBAR_VISIBILITY';
